import { gql } from '@apollo/client';

export const NAMES_SEARCH = gql`
  query SearchNames($searchTerm: String!, $searchType: SEARCH_TYPE!, $skip: Int, $size: Int, $sort: SortInput) {
    searchNames(data: {skip: $skip, searchTerm: $searchTerm, searchType: $searchType, size: $size, searchType: $searchType, sort: $sort}) {
      names {
        nameId
        nameValue
        nameType
        privacyType
        nameIsLegal
        nameIsni
        partyId
        partyType
        partyCountryOfOriginId
        partyCountryOfOriginName
        nameInternalComment
      }
      totalCount
    }
  }
`;
